.modalContainer {
    justify-content: safe center;
    overflow-y: auto;
    overflow-wrap: anywhere;
    flex-direction: column;
}

.Badge {
    color: var(--data-text-color, var(--badge-color));
}

.Radio {
    font-size: var(--mantine-font-size-xs);
}

.Timer {
    white-space: nowrap;
}

.Button {
    &:disabled {
        background-color: var(--mantine-color-gray-8);
    }
}

.TrainingImg {
    @media only screen and (max-width: 900px) {
        display: none;
    }
}
